import React, { useState, useEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import WidgetSkeleton from "../widget/WidgetSkeleton";
import am5geodata_indonesiaLow from "@amcharts/amcharts5-geodata/indonesiaLow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

type props = {
  petaOutbound: any;
  isLoadingPetaOutbound: boolean;
};
const Section3 = ({ petaOutbound, isLoadingPetaOutbound }: props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Outbound Volume");
  const [mapData, setMapData] = useState<any[]>([]);

  useEffect(() => {
    if (petaOutbound) {
      setMapData(petaOutbound.berat || []);
    }
  }, [petaOutbound]);
  const handleDropdownText = (
    event: React.MouseEvent<HTMLAnchorElement>,
    text: string
  ) => {
    event.preventDefault();
    setSelectedOption(text);
    setIsDropdownOpen(false);

    const data =
      petaOutbound?.[
        text === "Outbound Volume"
          ? "berat"
          : text === "Outbound Revenue"
          ? "revenue"
          : "invoice_unproduce"
      ] || [];

    setMapData(data);
  };

  useEffect(() => {
    let root: am5.Root;

    am5.ready(() => {
      if (root) {
        root.dispose();
      }

      const chartDiv = document.getElementById("chartdiv");
      if (chartDiv) {
        chartDiv.innerHTML = "";
      }

      root = am5.Root.new("chartdiv");

      root.setThemes([am5themes_Animated.new(root)]);

      const chart = root.container.children.push(
        am5map.MapChart.new(root, {
          panX: "rotateX",
          panY: "translateY",
          projection: am5map.geoMercator(),
        })
      );

      chart.set("maxZoomLevel", 10.5);
      chart.set("homeGeoPoint", {
        latitude: -2.5,
        longitude: 118.0,
      });
      chart.set("homeZoomLevel", 1.0);

      var zoomControl = chart.set(
        "zoomControl",
        am5map.ZoomControl.new(root, {})
      );
      zoomControl.homeButton.set("visible", true);

      var polygonSeries = chart.series.push(
        am5map.MapPolygonSeries.new(root, {
          geoJSON: am5geodata_indonesiaLow,
        })
      );

      polygonSeries.mapPolygons.template.setAll({
        fill: am5.color(0x000000),
        stroke: am5.color(0xffffff),
      });

      const pointSeries = chart.series.push(
        am5map.MapPointSeries.new(root, {})
      );

      pointSeries.bullets.push(function <
        D extends am5.DataItem<am5map.IMapPointSeriesDataItem>
      >(root: am5.Root, series: am5.Series, dataItem: D) {
        const angle = Math.random() * Math.PI * 2;
        const distance = 20 + Math.random() * 40;

        const offsetX = Math.cos(angle) * distance;
        const offsetY = Math.sin(angle) * distance;

        const container = am5.Container.new(root, {
          x: offsetX,
          y: offsetY,
        });

        const ctx = dataItem.dataContext as { title: string; value: string };
        let valueText = ctx.value;

        if (
          selectedOption === "Outbound Revenue" ||
          selectedOption === "Outbound Invoice Unproduce"
        ) {
          const number = Number(valueText);
          if (!isNaN(number)) {
            valueText = "Rp. " + number.toLocaleString("id-ID");
          }
        } else {
          const number = Number(valueText);
          if (!isNaN(number)) {
            valueText = number.toLocaleString("id-ID") + " Kg";
          } else {
            valueText += " Kg";
          }
        }

        container.children.push(
          am5.Label.new(root, {
            text:
              "[bold]" + ctx.title + " /[bold #ed1c24] " + valueText + "[/]",
            background: am5.Rectangle.new(root, {
              fill: am5.color("#dadad8"),
            }),
            paddingLeft: 5,
            paddingRight: 5,
            paddingTop: 2,
            paddingBottom: 2,
            centerX: am5.p50,
            centerY: am5.p50,
          })
        );

        return am5.Bullet.new(root, {
          sprite: container,
        });
      });

      pointSeries.data.setAll(
        mapData.map((city) => ({
          title: city.title,
          value: city.value,
          geometry: {
            type: "Point",
            coordinates: [city.longitude, city.latitude],
          },
        }))
      );
    });
    // Cleanup function
    return () => {
      if (root) {
        root.dispose();
      }
    };
  }, [mapData]);

  return (
    <div className="row mb-3">
      <div className="mb-2 col-lg-12">
        <div className="card pb-3 h-full min-h-[250px]" id="PetaCoverage">
          {isLoadingPetaOutbound && <WidgetSkeleton />}
          <div className="h-full">
            <div className="d-flex justify-content-between align-items-center p-3">
              <div className="dropdown">
                <button
                  className="btn text-dark bg-white fw-bold dropdown-custom p-0"
                  type="button"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <div className="d-flex align-items-center">
                    <div className="fw-bold dropdown-text px-3 py-2">
                      {selectedOption}
                    </div>
                    <div className="dropdown-arrow px-3 py-2">
                      <span className="arrow-size">▼</span>
                    </div>
                  </div>
                </button>
                <div
                  className={`dropdown-menu dropdown-menu-custom ${
                    isDropdownOpen ? "show" : ""
                  }`}
                >
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => handleDropdownText(e, "Outbound Volume")}
                  >
                    Outbound Volume
                  </a>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => handleDropdownText(e, "Outbound Revenue")}
                  >
                    Outbound Revenue
                  </a>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) =>
                      handleDropdownText(e, "Outbound Invoice Unproduce")
                    }
                  >
                    Outbound Invoice Unproduce
                  </a>
                </div>
                <div className="text-dark mt-1">by Main Origin City</div>
              </div>
            </div>
            <div className="petacoverage" id="chartdiv"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
